import { useTranslations } from "next-intl";
import { memo } from "react";
import { useFiltersList } from "@hooks/use-features";
import shouldHideFilterSectionInListingPage from "@utils/catalog-filters/shouldHideFilterSectionInListingPage";
import SectionButton from "./Elements/SectionButton";
import SectionContent from "./Elements/SectionContent";
import FilterCheckbox from "./Elements/FilterCheckbox";

const filterSectionKey = "colors";

const ColorsSection = memo(function ColorsSection({
  colorItems,
  refineColor,
  listingPage,
  onClose,
  filterSectionOpened,
  setFilterSectionOpened,
}) {
  const t = useTranslations("catalog");

  const filtersList = useFiltersList();

  if (shouldHideFilterSectionInListingPage(listingPage, "colors")) return null;
  if (colorItems.length < 2) return null;

  const sectionTitle = t(`filters.section_titles.${filterSectionKey}`);

  function displayColorsFiltersOptions() {
    const colorsFiltersList = filtersList.colors.map((filter) => ({
      key: filter,
      name: t(`filters.colors.${filter}`),
    }));
    colorsFiltersList.sort((a, b) => a.name.localeCompare(b.name));

    return colorsFiltersList.map((colorObject) => {
      const item = colorItems.find((colorItem) => colorItem.value === colorObject.key);

      if (!item) return;

      return (
        <FilterCheckbox
          key={`filter-${colorObject.key}`}
          label={colorObject.name}
          filterType="colors"
          filterSectionKey={filterSectionKey}
          item={item}
          refine={refineColor}
        />
      );
    });
  }

  const checkedFilters = {
    colors: filtersList.colors.filter(
      (color) => colorItems.find((item) => item.value === color)?.isRefined,
    ),
  };

  return (
    <div>
      <SectionButton
        checkedFilters={checkedFilters}
        filterTypesToDisplay={["colors"]}
        title={sectionTitle}
        onClick={() => setFilterSectionOpened(filterSectionKey)}
      />

      <SectionContent
        isOpen={filterSectionOpened === filterSectionKey}
        onClose={onClose}
        onGoBack={() => setFilterSectionOpened("")}
        title={sectionTitle}
      >
        {displayColorsFiltersOptions()}
      </SectionContent>
    </div>
  );
});

export default ColorsSection;
